/**
 * Banner Styles supported by the AppBanner widget
 */
export const BANNER_STYLES = {
    DEFAULT: 'default',
    HIGHLIGHT: 'highlight',
    WARNING: 'warning',
    INFO: 'info',
    DANGER: 'danger',
};
export const BANNER_STYLE_VALUES = Object.values(BANNER_STYLES);
//# sourceMappingURL=BannerStyle.js.map